import HeaderComponent from "components/card/HeaderComponent";
import { Wifi } from "lucide-react";
import React from "react";
import StaffListCard from "./StaffListCard";
import { staffLists } from "./staffLists";

const StaffStatusMonitoringList = () => {
  const totalStaff = staffLists.length;


  return (
      <HeaderComponent
        title="Staff Online - Global Distribution"
        description="Real-time status monitoring across locations"
        cardBorder="white-emerald"
        labelIcon={<Wifi className="w-6 h-6"/>}
        rightNav={
            <div className="flex items-center gap-2">
              <span className="text-[12px] muted-text">{totalStaff} Total Staff</span>
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75">
                </span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500">
                </span>
              </span>
            </div>
        }
      >
        <StaffListCard/>
      </HeaderComponent>
  );
};

export default StaffStatusMonitoringList;
